import {
  getFirestore,
  doc,
  serverTimestamp,
  setDoc,
  updateDoc,
  deleteDoc,
} from 'firebase/firestore';
import { app } from '../resources/gcp-config';
import { errorAlert, successAlert } from '../components/alerts';
import { v4 as uuidv4 } from 'uuid';

const db = getFirestore(app);

export const addInvoiceTemplate = async (formData) => {
  const invoiceTempId = uuidv4();
  formData.invoiceTempId = invoiceTempId;
  formData.updatedAt = serverTimestamp();
  // console.log(formData);
  try {
    await setDoc(doc(db, 'invoice-templates', invoiceTempId), formData);

    successAlert('Success!', 'A new invoice template has been added.');
  } catch (error) {
    console.error('Error saving invoice template:', error);
    errorAlert(
      'Error!',
      'An error occurred while saving the invoice template.'
    );
  }
};

export const deleteInvoiceTemplate = async (tempId) => {
  try {
    deleteDoc(doc(db, 'invoice-templates', tempId));
    successAlert('Success!', 'The template has been deleted.');
  } catch (error) {
    console.error('Error deleting template:', error);
    errorAlert('Error!', 'An error occurred while deleting the template');
  }
};

export const updateInvoiceTemplate = async (tempId, formData) => {
  try {
    await updateDoc(doc(db, 'invoice-templates', tempId), {
      ...formData,
      updatedAt: serverTimestamp(),
    });
    successAlert('Success!', 'The template has been updated.');
  } catch (error) {
    console.error('Error updating template:', error);
    errorAlert('Error!', 'An error occurred while updating the template');
  }
};
